import styled from 'foundations-theming/utils';
export const Svg = styled.svg.withConfig({
  displayName: "Svg"
})(({
  $size,
  $color,
  $alignWithText
}) => {
  return Object.assign({
    inlineSize: $size,
    blockSize: $size,
    fill: $color
  }, $alignWithText && {
    verticalAlign: '-0.1em' // This value was chosen based on the icon svg alignment within its viewbox
  });
});